import { gql } from 'react-apollo';

// GraphQL Queries
export const getRubricData = gql`
  query rubricData($assignmentId: String, $itemReference: String) {
    rubricData(assignmentId: $assignmentId, itemReference: $itemReference)
  }
`;
